/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BroadcastPeriod,
  BroadcastPeriodListParams,
  Pagination,
  BroadcastPeriodCreationParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class BroadcastPeriodService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(broadcastPeriodId: string): Observable<BroadcastPeriod> {
    return this._httpClient.get<BroadcastPeriod>(
      `${this._apiConstantsService.broadcastPeriodUrl}/${broadcastPeriodId}`
    );
  }

  list(
    params?: BroadcastPeriodListParams
  ): Observable<Pagination<BroadcastPeriod>> {
    return this._httpClient.get<Pagination<BroadcastPeriod>>(
      this._apiConstantsService.broadcastPeriodUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(data: BroadcastPeriodCreationParams): Observable<BroadcastPeriod> {
    return this._httpClient.post<BroadcastPeriod>(
      this._apiConstantsService.broadcastPeriodUrl,
      data
    );
  }

  update(
    broadcastPeriodId: string,
    data: Partial<BroadcastPeriodCreationParams>
  ): Observable<BroadcastPeriod> {
    return this._httpClient.patch<BroadcastPeriod>(
      `${this._apiConstantsService.broadcastPeriodUrl}/${broadcastPeriodId}`,
      data
    );
  }

  delete(broadcastPeriodId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.broadcastPeriodUrl}/${broadcastPeriodId}`
    );
  }
}
